export const CHANNEL_SETTINGS_MODAL_TABS = {
  INVITE_PEOPLE: 'INVITE_PEOPLE',
  SETTINGS: 'SETTINGS',
};
